import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconHomeSvg } from "./IconHomeSvg.mjs";
const IconHome = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconHomeSvg, ...iconProps });
};
export {
  IconHome
};
